import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import _ from 'lodash';

import template from '../../templates/ProjectScope/ProjectScopeCard.rt';
import * as actions from '../../actions';
import {selectItemUpdates, hasFabricatorItems} from '../../selectors';
import {AccessRights} from "../../schemas/accessRightsModel";
import * as helpers from '../../utilities/helpers';
// import {postQtCategories, toggleFeatureGroupImagePopup} from "../NewScope/newScopeActions";
import {toggleFeatureGroupImagePopup} from "../NewScope/newScopeActions";
import {updateFeatureGroups} from "./ProjectScopeActions";
// import {FEATURE_GROUP_ALL_NAME} from "../../constants/newScopeConstants";

const featureGroupHasFeatures = fg => {
  if (!fg.isComplex)
    return _.some(fg.features);
  return _.some(fg.subGroups, (v, k) => _.some(v.features))
}

const featureGroupIsVisible = fg => {
  if (!fg.isComplex)
    return fg.visible;
  return _.every(fg.subGroups, v => v.visible);
}

const featureGroupIsEnabled = fg => {
  if (!fg.isComplex) {
    return fg.enabled;
  }
  return _.every(fg.subGroups, v => v.enabled);
}

function mapStateToProps(state, props) {
  const {featureGroup} = props;

  const AR = AccessRights.get(state);
  const updatedFeatureGroup = selectItemUpdates(state, featureGroup);
  if (updatedFeatureGroup.isComplex) {
    _.forEach(_.keys(updatedFeatureGroup.subGroups), key => {
      updatedFeatureGroup.subGroups[key] = selectItemUpdates(state, featureGroup.subGroups[key]);
    });
  }

  return {
    visible: featureGroupIsVisible(updatedFeatureGroup),
    hasFabricatorItems: hasFabricatorItems(state, featureGroup),
    enabled: featureGroupIsEnabled(updatedFeatureGroup),
    updatedFeatureGroup,
    canEnableFeaturesGroups: AR.isSiteAdmin(false) || AR.isFabMaster() || AR.isFabAdmin(),
    AR,
    showDelete: AR.isSiteAdmin(true),
    canDelete: AR.isSiteAdmin(true) && !featureGroupHasFeatures(featureGroup)
    // qtCategories: state.newScope.qtCategories
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  const {featureGroup} = ownProps;
  return {
    onUpdateTransientField: (key, value) => {
      if (!featureGroup.isComplex) {
        dispatch(actions.updateTransientField(featureGroup, key, value));
      } else {
        _.forEach(featureGroup.subGroups, v => dispatch(actions.updateTransientField(v, key, value)));
      }
    },
    // postQtCategories: (qtCategories) => dispatch(postQtCategories(qtCategories)),
    updateFeatureGroups: (updatedFeatureGroup) => dispatch(updateFeatureGroups(updatedFeatureGroup)),
    toggleFeatureGroupImagePopup: (activeImageEditFeatureGroup) => dispatch(toggleFeatureGroupImagePopup(activeImageEditFeatureGroup))
  };
}

const getInitialImage = (featureGroup) => {
  let image = null;
  if(featureGroup.customImageUrl) {
    image = featureGroup.customImageUrl;
  } else if(featureGroup.image) {
    image = featureGroup.image;
  }
  if(image) {
    return image;
  }
  return null;
}

class projectScopeCard extends PureComponent {
  setInitialState = (props) => {
    this.setState({
      showInformation: false,
      customDisplayName: props.updatedFeatureGroup.customDisplayName || props.updatedFeatureGroup.name,
      customDescription: props.updatedFeatureGroup.customDescription || props.updatedFeatureGroup.description,
      unitText: props.updatedFeatureGroup.unitText,
      customImageUrl: getInitialImage(props.updatedFeatureGroup),
      defaultDisplayName: props.updatedFeatureGroup.name,
      defaultDescription: props.updatedFeatureGroup.description,
      editingDisplayName: false,
      editingDescription: false,
      editingImageUrl: false,
      acceptIncomingChanges: false
    }, this.forceUpdate);
  }

  isSelectedImage = (image) => {
    let url = helpers.getFeatureGroupIconURL(this.props.updatedFeatureGroup.name, this.props.updatedFeatureGroup.enabled);
    if(this.state.customImageUrl) {
      url = helpers.getFeatureGroupIconURL(this.state.customImageUrl, this.props.updatedFeatureGroup.enabled);
    }
    return _.endsWith(url, `/${image.replace('.svg', '') + '.svg'}`);
  }

  getImageUrl = () => {
    if(this.props.updatedFeatureGroup.customImageUrl && this.props.newScope) {
      return helpers.getFeatureGroupIconURL(this.props.updatedFeatureGroup.customImageUrl, this.props.updatedFeatureGroup.enabled);
    }
    if(this.state.customImageUrl && !this.props.newScope) {
      return helpers.getFeatureGroupIconURL(this.state.customImageUrl, this.props.updatedFeatureGroup.enabled);
    }
    return helpers.getFeatureGroupIconURL(this.props.updatedFeatureGroup.name, this.props.updatedFeatureGroup.enabled);
  };

  updateField = (key, value) => {
    this.props.onUpdateTransientField(key, value);
  };

  updateFeatureGroup = (updatedFeatureGroup) => {
    this.props.updateFeatureGroups(updatedFeatureGroup);
    // here we select every category with current filterGroup & update it // DISABLED for now, let's test without it
    // let categoriesToUpdate = this.props.qtCategories.filter(qtCategory => {
    //   return (qtCategory.name !== FEATURE_GROUP_ALL_NAME)
    //     && qtCategory.featureGroups.some(qtFeatureGroup => qtFeatureGroup.groupName === this.props.featureGroup.name)
    // });
    // if (categoriesToUpdate.length) {
    //   categoriesToUpdate = categoriesToUpdate.map(qtCategory => {
    //     qtCategory.featureGroups = qtCategory.featureGroups.map(qtFeatureGroup => {
    //       if (qtFeatureGroup.groupName === this.props.featureGroup.name) {
    //         qtFeatureGroup[key] = value;
    //       }
    //       return qtFeatureGroup
    //     });
    //     return qtCategory
    //   })
    // }
    // this.props.postQtCategories(categoriesToUpdate);
  };

  onChangeEnabled = (enabled) => {
    if (this.props.newScope) {
      const updatedFeatureGroup = this.props.featureGroup;
      if (updatedFeatureGroup.isComplex) {
        Object.keys(updatedFeatureGroup.subGroups).forEach(subGroup => {
          updatedFeatureGroup.subGroups[subGroup].enabled = enabled;
          return subGroup
        });
      }
      updatedFeatureGroup.enabled = enabled;
      this.updateFeatureGroup(updatedFeatureGroup);
    } else {
      this.updateField('enabled', enabled);
    }
  };

  onChangeVisible = (visible) => {
    if (this.props.newScope) {
      const updatedFeatureGroup = this.props.featureGroup;
      if (updatedFeatureGroup.isComplex) {
        Object.keys(updatedFeatureGroup.subGroups).forEach(subGroup => {
          updatedFeatureGroup.subGroups[subGroup].visible = visible;
          return subGroup
        });
      }
      updatedFeatureGroup.visible = visible;
      this.updateFeatureGroup(updatedFeatureGroup);
    } else {
      this.updateField('visible', visible);
    }
  };

  startEdit = (key) => {
    var newState = {
      ["editing" + key]: true
    };

    if(key === "DisplayName" && (!this.state.customDisplayName || !this.state.customDisplayName.length)) {
      newState.customDisplayName = this.props.updatedFeatureGroup.name;
    } else if(key === "Description" && (!this.state.customDescription || !this.state.customDescription.length)) {
      newState.customDescription = this.props.updatedFeatureGroup.description;
    }

    this.setState(newState, () => {
      let el = this["input" + key];
      if(el && el.focus) {
        el.focus();
        el.selectionStart = el.selectionEnd = el.value.length;
      }
    });
  };

  editImageClick = () => {
    if (this.props.newScope) {
      // console.log("this.props.featureGroup", this.props.featureGroup);
      this.props.toggleFeatureGroupImagePopup(this.props.featureGroup)
    } else {
      this.startEdit('ImageUrl')
    }
  };

  stopEdit = (key, value) => {
    this.setState({["editing" + key]: false, ["custom" + key]: value});
    let field = "";
    switch(key) {
      case "ImageUrl":
        field = "customImageUrl";
      break;
      case "DisplayName":
        field = "customDisplayName";
      break;
      case "Description":
        field = "customDescription";
      break;
      case "unitText":
        field = "unitText";
      break;
    }
    if (this.props.newScope) {
      const updatedFeatureGroup = this.props.featureGroup;
      updatedFeatureGroup[field] = value;
      this.updateFeatureGroup(updatedFeatureGroup);
    } else {
      this.updateField(field, value);
    }
  };

  getInfoButton = () => {
    return [{
      text: 'OK',
      onClick: () => {
        this.setState({showInformation: false});
      }
    }];
  }

  hideIconLibrary = () => {
    if(this.editingImageUrl) {
      this.setState({editingImageUrl: false});
    }
  }

  setAcceptIncomingChanges = () => this.setState({acceptIncomingChanges: true});
  componentWillMount() {
    this.setInitialState(this.props);
  }

  componentDidMount() {
    document.addEventListener("transientUpdatesCleared", this.setAcceptIncomingChanges);
    document.addEventListener("newFeatureGroupAdded", this.setAcceptIncomingChanges);
    document.addEventListener("click", this.hideIconLibrary);
  }
  componentWillUnmount() {
    document.removeEventListener("transientUpdatesCleared", this.setAcceptIncomingChanges);
    document.removeEventListener("newFeatureGroupAdded", this.setAcceptIncomingChanges);
    document.removeEventListener("click", this.hideIconLibrary);
  }
  componentDidUpdate(props) {
    if(this.state.acceptIncomingChanges) {
      this.setInitialState(props);
    }
  }
  handleDelete(featureGroup) {
    console.log("TODO: add feature group delete logic", featureGroup);
  }

  render = template
}

projectScopeCard.propTypes = {
  featureGroup: PropTypes.object.isRequired,
  onUpdateTransientField: PropTypes.func.isRequired,
  removeFeatureGroupFromCategory: PropTypes.func,
  newScope: PropTypes.bool
};

const ProjectScopeCard = connect(mapStateToProps, mapDispatchToProps)(projectScopeCard);

export default ProjectScopeCard;
